import React, {useCallback, useEffect, useRef, useState} from 'react';

import '../css/reset.css';
import './_Index.scss';
//import styles from './_Index.style';

import {
    Form as NForm,
    Popover,
    Button,
    Modal,
    message,
    Upload,
    Input,
    Space,
    Select,
    Collapse,
    DatePicker,
    Checkbox, Spin
} from 'antd';

import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import {StaticEvent} from "../_/StaticEvent";
import _ from "../_";

import {Link} from 'react-router-dom';

import {
    useParams,
    useNavigate
} from "react-router-dom";
import {PageDataManager} from "../hooks/UsePageDataManager";

import {Field, Form} from "react-final-form";
import {SessionManager} from "../hooks/UseSessionManager";
import {NavigateFunction} from "react-router";

import {
    LoadingOutlined,
    LockOutlined,
    PlusOutlined,
    RedoOutlined,
    UserOutlined,
    EditOutlined,
    UploadOutlined,
    DeleteFilled
} from "@ant-design/icons";
import {lastValueFrom} from "rxjs";
import UseLoadingManager from "../hooks/UseLoadingManager";
import UseCompState from "../hooks/UseCompState";

import Partial_Appointment__Modal_AddPet from "./Partial_Appointment__Modal_AddPet";
import ImgCrop from "antd-img-crop";

var moment = require('moment');
const {Option} = Select;
const {Panel} = Collapse;
const dateFormat = 'YYYY-MM-DD';

const {TextArea} = Input;

type ViewModelProps = {
    refModal: any,

    用戶No?: any,
};
type Props = {
    PrefixTarget?: string;
    pageDataManager: PageDataManager
    sessionManager: SessionManager,
    navigate: NavigateFunction,
    parentState?: any,

    viewModel: ViewModelProps,
};

export default function Partial_Manage_Staff__Pane_EditOrAddStaff(props: Props) {
    let PrefixTarget: string = props.PrefixTarget || ('Partial_Manage_Staff__Pane_EditOrAddStaff'+(props.viewModel.用戶No ?? "0"));
    let pageDataManager: PageDataManager = props.pageDataManager;
    let sessionManager: SessionManager = props.sessionManager;
    let navigate: NavigateFunction = props.navigate;

    //const [viewModel, setViewModel] = useState<ViewModelProps>(props.viewModel);
    const viewModel: any = props.viewModel;
    const isNew = !viewModel.用戶No;

    const layout = {
        labelCol: {span: 5},
        wrapperCol: {span: 19},
    };

    const layout02 = {
        labelCol: {span: 0},
        wrapperCol: {span: 25},
    };

    //#region ForceRender Control
    const [, setForceRender] = useState(false);
    const forceRender = () => {
        setForceRender(s => !s);
    };
    //#endregion

    const loadingManager = UseLoadingManager({shouldReRenderOnLoading: false});

    //#region Boot
    let _refDoLoadPartialData: any = useRef<{ alwaysLoad?: boolean }>(null);
    useEffect(() => {
        const _loadPartialData = async (): Promise<void> => {

            // VALIDATE INPUT
            const moreParams: any = {};
            const p1 = viewModel.用戶No;
            if (!p1) {
                //return; //ERROR INPUTS
            } else {
                moreParams.p1 = p1;
            }

            // WAITING SCREEN
            loadingManager.changeLoadingCount(+1);
            //StaticEvent.LoadingEvent.next(true);

            // POST
            let postData = {
                ...moreParams,
                timezoneOffset: (new Date()).getTimezoneOffset() * 60 * 1000,
            };
            const postUrl = ApiService.urlMapping('~/pet_api/1/partial_modalbody_editstaff');
            const post$ = Static.apiService.post(postUrl, postData);
            post$.subscribe(async (res: any) => {
                    // CLOSE WAITING SCREEN
                    loadingManager.changeLoadingCount(-1);
                    //StaticEvent.LoadingEvent.next(false);

                    let data = res.data;
                    let error = data.error || null;
                    let result = error == null;

                    if (result) { // SUCEESS
                        let payload = data.payload;
                        _._debug.warn(payload);

                        //delete pageDataManager.refPageData.current[TabControlState]?.['MyCollectionTab_data'];

                        pageDataManager.emptyZone(PrefixTarget);
                        let changeShard = {
                            [PrefixTarget]: {
                                ...payload,
                            }
                        }
                        pageDataManager.merge(changeShard);
                        pageDataManager.apply();

                        forceRender();
                    } else {
                        // AUTH USER EXPIRED T:1
                        if (error.code == 2) {
                            await sessionManager.setLogout();
                            Static.NavAwayToLogin(pageDataManager, navigate)(null);
                            return;
                        }

                        _._debug.error(error);
                        alert(error.message);
                    }
                }, async (err) => {

                    // CLOSE WAITING SCREEN
                    loadingManager.changeLoadingCount(-1);
                    //StaticEvent.LoadingEvent.next(false);
                    _._debug.warn(err);
                    alert('網路連線有問題');
                }
            );
            return lastValueFrom(
                post$
            );
        }
        const doLoadPartialData = async ({alwaysLoad = false}): Promise<void> => {
            // if (!pageDataManager.refPageData.current.Root) {
            //     return;
            // }
            /// do not dynamically load data if condition fits.
            if (!alwaysLoad) {
                if (pageDataManager.isZoneExist(PrefixTarget)) {
                    return;
                }
            }

            if (!isNew) {
                await _loadPartialData();
            } else {
                pageDataManager.emptyZone(PrefixTarget);
                pageDataManager.merge({
                    [PrefixTarget]: {}
                });
                pageDataManager.apply();

                forceRender();
            }
        }


        _refDoLoadPartialData.current = doLoadPartialData;
        _refDoLoadPartialData.current({});
    }, [pageDataManager.get(PrefixTarget)]);
    //#endregion

    //#region Set Body
    const handleClose = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (viewModel.refModal?.current) {
            viewModel.refModal.current.destroy();
        }
    };

    const isModalContained = () => {
        return !!viewModel.refModal?.current;
    }

    const Body = () => {
        const RegionEmptyShow = false;
        const RegionLoadingShow = true;
        const RegionInitialLoadingShow = false;

        const PassPageDataInitalized = pageDataManager.refPageData.current != null;
        const PassPrefixTargetLoaded = pageDataManager.get(`${PrefixTarget}`) !== null;

        let Item_用戶 = pageDataManager.get(`${PrefixTarget}.Item_用戶`);
        let List_用戶: any = Item_用戶 ? [Item_用戶] : [null];

        //#region Handlers
        const handleValidate = values => {
            const errors: any = {};

            // if (!values.網址) {
            //     errors.網址 = '↑ 欄位為必填';
            // } else {
            //     function isUrlValid(userInput) {
            //         var res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
            //         if(res == null)
            //             return false;
            //         else
            //             return true;
            //     }
            //
            //     if (!isUrlValid(values.網址)) {
            //         errors.網址 = '↑ 此連結無效，請輸入正確連結';
            //     }
            // }
            //
            // if (!values.ownername) {
            //     errors.ownername = '↑ 欄位為必填';
            // } else {
            // }
            //
            // if (!values.cellphone) {
            //     errors.cellphone = '↑ 欄位為必填';
            // } else {
            // }

            return errors;
        };

        const handleSubmit_save = (e: any, v: any) => {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            let hide = message.loading({
                type: 'loading',
                className: 'myMessage',
                content: <div className="myMessageBody">驗證中...</div>,
                key: 'loading',
                duration: 0
            });

            // VALIDATE INPUT
            const p1 = v;
            if (!p1) {
                _._debug.error(p1);
                return; //ERROR INPUTS
            }

            // WAITING SCREEN
            loadingManager.changeLoadingCount(+1);
            //StaticEvent.LoadingEvent.next(true);

            // POST
            let postData = {
                p1,
                timezoneOffset: (new Date()).getTimezoneOffset() * 60 * 1000,
            };
            const postUrl = ApiService.urlMapping('~/pet_api/1/_partial_modalbody_editstaff');
            const post$ = Static.apiService.post(postUrl, postData);
            post$.subscribe(async (res: any) => {
                    hide();

                    // CLOSE WAITING SCREEN
                    loadingManager.changeLoadingCount(-1);
                    //StaticEvent.LoadingEvent.next(false);

                    let data = res.data;
                    let error = data.error || null;
                    let result = error == null;

                    if (result) { // SUCEESS
                        let payload = data.payload;
                        _._debug.warn(payload);


                        if (isNew) {
                            message.success({content: '新增完成!', duration: 2});
                        } else {
                            message.success({content: '修改完成!', duration: 2});
                        }

                        if (isModalContained()) {
                            handleClose(null);
                        } else {
                            _refDoLoadPartialData.current({alwaysLoad: true});
                        }

                        viewModel?.OnUpdated?.(payload);

                        if (viewModel.用戶No === null) { //is insert
                            StaticEvent.castUpdateEvent({
                                command: StaticEvent.UpdateFacade.Command.Add_用戶,
                                Add_用戶: {
                                    用戶No: payload.Item_用戶.用戶No,
                                }
                            });
                        } else {
                            StaticEvent.castUpdateEvent({
                                command: StaticEvent.UpdateFacade.Command.Update_用戶,
                                Update_用戶: {
                                    用戶No: payload.Item_用戶.用戶No,
                                }
                            });
                        }
                        // let carryData = _._u.update(payload,
                        //     {
                        //         $merge: {
                        //             Tokens: payload?.Tokens,
                        //         },
                        //         Item_飼主: {
                        //             $set: payload?.Item_飼主,
                        //         }
                        //     }
                        // );
                        // carryData.Item_飼主 = p1;
                        // if (onDone) {
                        //     const ret = onDone(carryData);
                        //     if (ret === 'demo') {
                        //         createModalPet(null, {
                        //             carryData,
                        //         })
                        //     }
                        // } else {
                        //     alert('onDone not defined');
                        // }
                    } else {
                        // AUTH USER EXPIRED
                        if (error.code == 2) {
                            //alert('帳號被登出，請重新登入');
                            //window.location.href = '/login';
                            //this.props.history.push('/login')
                            await sessionManager.setLogout();
                            pageDataManager.clear();
                            pageDataManager.reloadAsync({alwaysLoad: true});
                            alert('時間逾時已被登出');
                            return;
                        }

                        _._debug.error(error);
                        alert(error.message);
                    }
                }, async (err) => {
                    hide();

                    // CLOSE WAITING SCREEN
                    loadingManager.changeLoadingCount(-1);
                    //StaticEvent.LoadingEvent.next(false);
                    _._debug.warn(err);
                    alert('網路連線有問題');
                }
            );
            return lastValueFrom(
                post$
            );
        }
        //#endregion

        if (!PassPrefixTargetLoaded) {
            if (RegionInitialLoadingShow) {
                return <React.Fragment>
                    <div className="d3">
                        <div>Loading.</div>
                    </div>
                </React.Fragment>;
            } else {
                return null;
            }
        }

        if (loadingManager.getIsLoading()) {
            if (RegionLoadingShow) {
                return <React.Fragment>
                    <div className="d3">
                        <Spin indicator={
                            <LoadingOutlined style={{fontSize: 24}} spin/>
                        }/>
                    </div>
                </React.Fragment>;
            } else {
                return null;
            }
        }

        if (List_用戶 && List_用戶.length > 0) {
            return <React.Fragment>
                {List_用戶.map(Item_用戶 => {
                    return <React.Fragment key={Item_用戶?.用戶No ?? "0"}>
                        <Form
                            onSubmit={(v) => handleSubmit_save(null, v)}
                            initialValues={{
                                ...Item_用戶,
                                ...(Item_用戶?.登入密碼 ? {登入密碼2: Item_用戶.登入密碼} : {})
                            }}
                            validate={handleValidate}
                            render={({
                                         submitError,
                                         handleSubmit,
                                         submitting,
                                         pristine,
                                         valid,
                                         error,
                                         values
                                     }) => {

                                return <React.Fragment>

                                    <div className="form_body">
                                        <form
                                            onSubmit={handleSubmit}
                                            {...layout}>

                                            <div className="photouploadbox">
                                                <div className="photoupload">
                                                    <Upload
                                                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                                        listType="picture"

                                                    >
                                                        <Button icon={<UploadOutlined/>}>上傳照片</Button>
                                                    </Upload>
                                                </div>
                                            </div>

                                            <div className="vt-page m_c2table">
                                                <div className="vt-col">
                                                    <div className="inbox">
                                                        <h3>基本資料</h3>

                                                        <div className="formbox">
                                                            <Field parse={_.bs.identity} name='名稱'
                                                                   validate={_.bs.Form.required}>
                                                                {
                                                                    ({input, meta}) => (
                                                                        <React.Fragment>
                                                                            <NForm.Item  {...layout}
                                                                                         label="員工姓名:"
                                                                                         name="staffname"
                                                                                         rules={[{
                                                                                             required: true,
                                                                                             message: '此為必填欄位'
                                                                                         }]}
                                                                            >
                                                                                <Input {...input} placeholder="請輸入中英文"/>
                                                                                {meta.touched && meta.error &&
                                                                                <div className="error">
                                                                                    {meta.error}
                                                                                </div>}
                                                                            </NForm.Item>
                                                                        </React.Fragment>
                                                                    )
                                                                }
                                                            </Field>
                                                            <Field parse={_.bs.identity} name='職稱'
                                                                   validate={_.bs.Form.required}>
                                                                {
                                                                    ({input, meta}) => (
                                                                        <React.Fragment>
                                                                            <NForm.Item  {...layout}
                                                                                         label="職稱:"
                                                                                         name="職稱"
                                                                                         rules={[{
                                                                                             required: false,
                                                                                             message: '此為必填欄位'
                                                                                         }]}
                                                                            >
                                                                                <Input {...input} placeholder="請輸入職稱"/>
                                                                                {meta.touched && meta.error &&
                                                                                <div className="error">
                                                                                    {meta.error}
                                                                                </div>}
                                                                            </NForm.Item>
                                                                        </React.Fragment>
                                                                    )
                                                                }
                                                            </Field>
                                                            <Field parse={_.bs.identity} name='權限'
                                                                   validate={_.bs.Form.required}>
                                                                {
                                                                    ({input, meta}) => (
                                                                        <React.Fragment>
                                                                            <NForm.Item  {...layout} {...input}
                                                                                         label="權限等級:"
                                                                                         name="authority"
                                                                                         rules={[{
                                                                                             required: true,
                                                                                             message: '此為必填欄位'
                                                                                         }]}
                                                                            >
                                                                                <Select {...input} placeholder='請選擇等級'
                                                                                        defaultValue="一般">
                                                                                    <Option value="一般">一般</Option>
                                                                                    <Option value="高階">高階</Option>
                                                                                    <Option value="醫生">醫生</Option>
                                                                                    <Option value="院長">院長</Option>
                                                                                </Select>
                                                                                {meta.touched && meta.error &&
                                                                                <div className="error">
                                                                                    {meta.error}
                                                                                </div>}
                                                                            </NForm.Item>
                                                                        </React.Fragment>
                                                                    )
                                                                }
                                                            </Field>
                                                            <Field parse={_.bs.identity} name='到職日'>
                                                                {
                                                                    ({input, meta}) => {

                                                                        const datepickerProps: any = {};
                                                                        if (input.value) {
                                                                            //props.defaultValue =moment.utc(input.value).format('YYYY-MM-DD');
                                                                            datepickerProps.defaultValue = moment(input.value);
                                                                        }
                                                                        datepickerProps.onChange = input.onChange;

                                                                        return <React.Fragment>
                                                                            <NForm.Item  {...layout}
                                                                                         label="到職日:"
                                                                                         name="ondutyday"
                                                                            >
                                                                                <DatePicker {...datepickerProps}
                                                                                    //format={dateFormat}
                                                                                            placeholder='請輸入日期'/>
                                                                                {meta.touched && meta.error &&
                                                                                <div className="error">
                                                                                    {meta.error}
                                                                                </div>}
                                                                            </NForm.Item>
                                                                        </React.Fragment>
                                                                    }
                                                                }
                                                            </Field>
                                                            <Field parse={_.bs.identity} name='Email'
                                                                   validate={_.bs.Form.required}>
                                                                {
                                                                    ({input, meta}) => (
                                                                        <React.Fragment>
                                                                            <NForm.Item  {...layout} {...input}
                                                                                         label="E-mail:"
                                                                                         name="email"
                                                                                         rules={[{
                                                                                             required: true,
                                                                                             message: '此為必填欄位'
                                                                                         }]}
                                                                            >
                                                                                <Input {...input}
                                                                                       placeholder="xxx@vetsion.com.tw"/>
                                                                                {meta.touched && meta.error &&
                                                                                <div className="error">
                                                                                    {meta.error}
                                                                                </div>}
                                                                            </NForm.Item>
                                                                        </React.Fragment>
                                                                    )
                                                                }
                                                            </Field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="vt-col">
                                                    <h3>帳號相關</h3>

                                                    <div className="formbox">
                                                        <Field parse={_.bs.identity} name='登入名稱'
                                                               validate={_.bs.Form.required}>
                                                            {
                                                                ({input, meta}) => (
                                                                    <React.Fragment>
                                                                        <NForm.Item  {...layout} {...input}
                                                                                     label="帳號:"
                                                                                     name="account"
                                                                                     rules={[{
                                                                                         required: true,
                                                                                         message: '此為必填欄位'
                                                                                     }]}
                                                                        >
                                                                            <Input {...input} placeholder="請輸入英文字母及數字"/>
                                                                            {meta.touched && meta.error &&
                                                                            <div className="error">
                                                                                {meta.error}
                                                                            </div>}
                                                                        </NForm.Item>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        </Field>

                                                        <Field parse={_.bs.identity} name='登入密碼'
                                                               validate={_.bs.Form.required}>
                                                            {
                                                                ({input, meta}) => (
                                                                    <React.Fragment>
                                                                        <NForm.Item  {...layout} {...input}
                                                                                     label="密碼:"
                                                                                     name="password"
                                                                                     rules={[{
                                                                                         required: true,
                                                                                         message: '此為必填欄位'
                                                                                     }]}
                                                                        >
                                                                            <Input.Password {...input} />
                                                                            {meta.touched && meta.error &&
                                                                            <div className="error">
                                                                                {meta.error}
                                                                            </div>}
                                                                        </NForm.Item>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        </Field>

                                                        <Field parse={_.bs.identity} name='登入密碼2'
                                                               validate={_.bs.Form.required}>
                                                            {
                                                                ({input, meta}) => (
                                                                    <React.Fragment>
                                                                        <NForm.Item  {...layout} {...input}
                                                                                     label="確認密碼:"
                                                                                     name="checkpassword"
                                                                                     rules={[{
                                                                                         required: true,
                                                                                         message: '此為必填欄位'
                                                                                     }]}
                                                                        >
                                                                            <Input.Password {...input}  />
                                                                            {meta.touched && meta.error &&
                                                                            <div className="error">
                                                                                {meta.error}
                                                                            </div>}
                                                                        </NForm.Item>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                </div>
                                            </div>

                                            <React.Fragment>
                                                <NForm.Item>
                                                    <div className="form_footer">
                                                        {isModalContained() && <React.Fragment>
                                                            <Button type='primary' danger ghost
                                                                    onClick={(e) => handleClose(e)}>放棄編輯</Button>
                                                        </React.Fragment>
                                                        }
                                                        <Button type='primary' htmlType="submit"
                                                                onClick={handleSubmit}
                                                                disabled={(submitting)}
                                                        >儲存</Button>
                                                    </div>
                                                </NForm.Item>
                                            </React.Fragment>

                                        </form>
                                    </div>
                                </React.Fragment>;
                            }}
                        />
                    </React.Fragment>
                })}
            </React.Fragment>;
        } else if (List_用戶 && List_用戶.length === 0) {
            if (RegionEmptyShow) {
                return <React.Fragment>
                    <div>Empty.</div>
                </React.Fragment>;
            }
        }

        return null;
    };
    //#endregion

    //#region Render
    return <React.Fragment>
        {Body()}
    </React.Fragment>;
    //#endregion
}
Partial_Manage_Staff__Pane_EditOrAddStaff.displayName = 'Partial_Manage_Staff__Pane_EditOrAddStaff';
